export default __webpack_public_path__ + "static/media/be-sure-step4.14473621.png";